// This file is part of Invenio-RDM-Records
// Copyright (C) 2020-2023 CERN.
// Copyright (C) 2020-2022 Northwestern University.
// Copyright (C) 2021 Graz University of Technology.
//
// Invenio-RDM-Records is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

import React, { useState, useEffect } from "react";
import { Button, Form, Icon } from "semantic-ui-react";
import PropTypes, { array } from "prop-types";
import { FieldLabel } from "react-invenio-forms";
import _unickBy from "lodash/unionBy";
import _get from "lodash/get";
import { i18next } from "@translations/i18next";
import { SelectField } from "@js/invenio_modular_deposit_form/replacement_components/SelectField";
import { TextField } from "@js/invenio_modular_deposit_form/replacement_components/TextField";
import { FieldArray, useFormikContext } from "formik";

const newIdentifier = { scheme: "", identifier: "" };

const idTypeData = {
  orcid: { text: "ORCID", value: "orcid", key: "orcid" },
  isni: { text: "ISNI", value: "isni", key: "isni" },
  gnd: { text: "GND", value: "gnd", key: "gnd" },
  ror: { text: "ROR", value: "ror", key: "ror" },
  kc_username: { text: "KC username", value: "kc_username", key: "kc_username" },
  email: { text: "email", value: "email", key: "email" },
};

const CreatibutorsIdentifiers = ({
  fieldPath,
  label = i18next.t("Name identifiers"),
  placeholder = "",
  idTypes = ["orcid", "isni", "gnd", "ror", "kc_username", "email"],
}) => {

  const [identifiersLength, setIdentifiersLength] = useState(-1);
  const [haveChangedNumber, setHaveChangedNumber] = useState(false);

  // const { values, formikProps } = useFormikContext();
  // console.log("formikProps", formikProps);

  const handleAddNew = (arrayHelpers, newItem) => {
    setHaveChangedNumber(true);
    arrayHelpers.push(newItem);
    setIdentifiersLength(identifiersLength + 1);
  };

  const handleRemove = (arrayHelpers, index) => {
    setHaveChangedNumber(true);
    arrayHelpers.remove(index);
    setIdentifiersLength(identifiersLength - 1);
  };

  // const handleChange = ({ data, formikProps, index }) => {
  //   console.log("handleChange", { data, formikProps, index });
  // console.log("handleChange formikProps", formikProps);
  // const subField = formikProps.fieldPath.split(".")[2];
  // const newOptions = selectedOptions.map((option, i) =>
  //   i === index ? { ...option, [subField]: data.value } : option
  // );
  // console.log("newOptions", newOptions);
  // setSelectedOptions(newOptions);
  // formikProps.form.setFieldValue(formikProps.fieldPath, data.value);
  // };

  return (
    <Form.Field className="creator-identifiers">
      <FieldLabel htmlFor={`${fieldPath}`} label={label} />
      <FieldArray
        addButtonLabel={i18next.t("Add other titles")}
        name={fieldPath}
        render={(arrayHelpers) => (
          <>
            {_get(arrayHelpers.form.values, fieldPath, [])?.map(
              (option, index) => {
                const fieldPathPrefix = `${fieldPath}.${index}`;

                return (
                  <Form.Group
                    key={index}
                    inline
                    className={`creatibutors-identifiers-item-row`}
                  >
                    <TextField
                      fieldPath={`${fieldPathPrefix}.identifier`}
                      name={`${fieldPathPrefix}.identifier`}
                      id={`${fieldPathPrefix}.identifier`}
                      label={""}
                      width={10}
                      required
                      classnames="flex-grow"
                    />
                    <SelectField
                      fieldPath={`${fieldPathPrefix}.scheme`}
                      name={`${fieldPathPrefix}.scheme`}
                      id={`${fieldPathPrefix}.scheme`}
                      label={"Scheme"}
                      options={idTypes.map((option) => idTypeData[option])}
                      required
                      selection
                      selectOnBlur
                      optimized
                      fluid
                      classnames="flex-grow"
                    />
                    <Form.Field className="no-label">
                      <Button
                        aria-label={i18next.t("Remove item")}
                        className="close-btn"
                        icon
                        onClick={() => handleRemove(arrayHelpers, index)}
                      >
                        <Icon name="close" />
                      </Button>
                    </Form.Field>
                  </Form.Group>
                );
              }
            )}

            <Button
              type="button"
              onClick={() => handleAddNew(arrayHelpers, newIdentifier)}
              icon
              className="align-self-end add-btn creatibutors-identifiers-add-button"
              labelPosition="left"
              id={`${fieldPath}.add-identifier-button`}
            >
              <Icon name="add" />
              Add identifier
            </Button>
          </>
        )}
      />
    </Form.Field>
  );
};

CreatibutorsIdentifiers.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

export { CreatibutorsIdentifiers };
